module.exports = __webpack_public_path__ + "img/paytable_icon.7dd4513e.svg";